<div class="d-flex mb-3 align-items-center">
    <div>
        <button
            class="filter-button"
            cmpsIconButton
            [cmpsOverlayTrigger]="filterTpl"
            placement="bottom-left"
        >
            <cmps-icon svgIcon="filter-outline"></cmps-icon>
            <span cmpsIconButtonLabel>{{
                _i18n._7360_FILTER | translate
            }}</span>
        </button>
        <ng-template
            let-overlay="overlay"
            #filterTpl
        >
            <cmps-filter
                class="cmps-coaching-detail-pillar-two-transcript-summary--transcript-filter"
                [overlay]="overlay"
            >
                <cmps-filter-category-header>{{
                    _i18n._11129_DATE_FILTERS | translate
                }}</cmps-filter-category-header>
                <cmps-filter-category-body>
                    <cmps-chip-list>
                        <ng-container>
                            <button
                                cmpsChip
                                [selected]="
                                    state?.filterOpts?.enabledFilters[
                                        _dateFilterType.Created
                                    ]
                                "
                                [value]="
                                    state?.filterOpts?.enabledFilters['created']
                                "
                                (click)="
                                    _onToggleDateFilter(_dateFilterType.Created)
                                "
                            >
                                {{ _i18n._7329_CREATED_ON | translate }}
                            </button>

                            <button
                                cmpsChip
                                [selected]="
                                    state?.filterOpts?.enabledFilters[
                                        _dateFilterType.LastUpdated
                                    ]
                                "
                                [value]="
                                    state?.filterOpts?.enabledFilters[
                                        'lastUpdated'
                                    ]
                                "
                                (click)="
                                    _onToggleDateFilter(
                                        _dateFilterType.LastUpdated
                                    )
                                "
                            >
                                {{ _i18n._11127_LAST_UPDATED_ON | translate }}
                            </button>
                        </ng-container>
                    </cmps-chip-list>
                </cmps-filter-category-body>
                <cmps-filter-category-header>{{
                    _i18n._11128_CREATED | translate
                }}</cmps-filter-category-header>
                <cmps-filter-category-body>
                    <cmps-date-range
                        [dateRange]="state?.filterOpts?.createdRange"
                        (dateRangeChange)="_onDateRangeFilterChange($event)"
                    >
                    </cmps-date-range>
                </cmps-filter-category-body>

                <cmps-filter-category-header>{{
                    _i18n._9923_LAST_UPDATED | translate
                }}</cmps-filter-category-header>
                <cmps-filter-category-body>
                    <cmps-date-range
                        [dateRange]="state?.filterOpts?.lastUpdatedOnRange"
                        (dateRangeChange)="_onLastUpdatedOnFilterChange($event)"
                    >
                    </cmps-date-range>
                </cmps-filter-category-body>
                <cmps-filter-category-header>{{
                    _i18n._7330_CREATED_BY | translate
                }}</cmps-filter-category-header>
                <cmps-filter-category-body>
                    <cmps-chip-list>
                        <ng-container
                            *ngFor="let user of state?.filterCreators"
                        >
                            <button
                                class="creator-tag"
                                cmpsChip
                                [value]="user"
                                [selected]="
                                    state?.filterOpts?.createdBy?.includes(user)
                                "
                                (click)="_onCreatedByFilterClick(user)"
                            >
                                <span>{{ user }}</span>
                            </button>
                        </ng-container>
                    </cmps-chip-list>
                </cmps-filter-category-body>
                <cmps-filter-category-header>{{
                    _i18n._11126_LAST_UPDATED_BY | translate
                }}</cmps-filter-category-header>
                <cmps-filter-category-body>
                    <cmps-chip-list>
                        <ng-container
                            *ngFor="let user of state?.filterUpdaters"
                        >
                            <button
                                class="updater-tag"
                                cmpsChip
                                [value]="user"
                                [selected]="
                                    state?.filterOpts?.lastUpdatedBy?.includes(
                                        user
                                    )
                                "
                                (click)="_onLastUpdatedByFilterClick(user)"
                            >
                                <span>{{ user }}</span>
                            </button>
                        </ng-container>
                    </cmps-chip-list>
                </cmps-filter-category-body>
            </cmps-filter>
        </ng-template>
    </div>
    <div class="ctos-header flex-grow-1">
        {{ _i18n._9487_COMMITMENT_NARRATIVE | translate }}
    </div>
</div>
<div class="grid-header">
    <p class="cell lg">{{ _i18n._7330_CREATED_BY | translate }}</p>
    <p class="cell md">{{ _i18n._965_DATE | translate }}</p>
    <p class="cell flex">{{ _i18n._9698_NOTE | translate }}</p>
</div>

<div
    class="cmps-commitment-narrative--grid-row"
    [class.cmps-commitment-narrative--grid-row-last]="last"
    [attr.data-diffitemid]="r.ctx.notes[0]?.diffItemId"
    *ngFor="
        let r of state?.filteredRow;
        trackBy: trackByFn;
        let last = last;
        let i = index
    "
>
    <div
        class="cmps-commitment-narrative--grid-row--content-top"
        (click)="_onToggleExpandClick(r.id)"
    >
        <p class="cell lg">{{ r.ctx.createdBy }}</p>
        <p class="cell md">{{ r.ctx.date | date: 'MMM-dd-y' }}</p>
        <p class="cell flex">{{ r.ctx.context }}</p>
    </div>

    <div *ngIf="r.ctx.isExpanded">
        <div class="grid-subheader">
            <div class="cell">
                <p class="subheader-title">
                    {{ _i18n._7330_CREATED_BY | translate }}
                </p>
                <p class="subheader-content">{{ r.ctx.createdBy }}</p>
            </div>
            <div class="cell">
                <p class="subheader-title">
                    {{ _i18n._7329_CREATED_ON | translate }}
                </p>
                <p class="subheader-content">
                    {{ r.ctx.date | date: 'MMM-dd-y' }}
                </p>
            </div>
            <div class="cell">
                <p class="subheader-title">
                    {{ _i18n._11126_LAST_UPDATED_BY | translate }}
                </p>
                <p class="subheader-content">{{ r.ctx.lastUpdatedBy }}</p>
            </div>
            <div class="cell">
                <p class="subheader-title">
                    {{ _i18n._11127_LAST_UPDATED_ON | translate }}
                </p>
                <p class="subheader-content">
                    {{ r.ctx?.lastUpdatedOn | date: 'MMM-dd-y' }}
                </p>
            </div>
        </div>

        <div
            cmpsNotes
            [formControl]="getNoteControl(i)"
            [config]="noteEntity"
            [defaultCategory]="_NoteCategory.GENERAL_NOTE"
            [hasTagBar]="false"
            [hasCategoryBar]="false"
            [showHeader]="true"
        ></div>
    </div>
</div>

<div class="d-flex justify-content-center pt-3">
    <button
        [disabled]="_disabled"
        (click)="_onAddNote()"
        cmpsIconButton
    >
        <cmps-icon svgIcon="note"></cmps-icon>
        <span cmpsIconButtonLabel>{{
            _i18n._9488_ADD_COMMITMENT_NOTE | translate
        }}</span>
    </button>
</div>
